<script>
import Blank from "@/components/icons/Blank.vue";
import IconBase from "@/components/IconBase.vue";

export default {
  name: "MyNav",
  components: { IconBase, Blank },
  props: {
    isFooter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      nameRoute: "",
      typeHidden: "opacity",
      isMobile: false,
      collapse: {
        first: false,
        second: false,
        third: false,
      },
    };
  },
  watch: {
    $route(value) {
      this.nameRoute = value.name;
    },
  },
  computed: {
    isHashUrl() {
      return (
        window.location.pathname.includes("midcareer") ||
        this.$route.name === "midcareer"
      );
    },
    linkPdf() {
      return `${process.env.BASE_URL}pdf/Kureha_Job_Hunting_Harassment_Prevention_Policy.pdf`
    }
  },
  methods: {
    handleScrollTo(element) {
      if (window.location.pathname.includes("midcareer")) {
        const section = document.querySelector(element);
        const isExistOpen = document.querySelector(".main_nav");
        const navButton = document.querySelector(".nav_button");
        if (section) {
          setTimeout(() => {
            window.scrollTo({
              top: section.offsetTop,
              behavior: "smooth",
            });
          }, 100);
          document.body.style.overflowY = "auto";
          if (isExistOpen) {
            isExistOpen.classList.remove("open");
            navButton.classList.remove("open");
          }
        }
        return;
      }
      this.$router.push({ name: "midcareer", hash: "#employee" });
    },
    handleCollapseHeader() {
      if (window.innerWidth > 901) {
        this.handleCollapse("second");
      }
    },
    handleCollapse(key) {
      this.collapse[key] = !this.collapse[key];
    },
    handleResize: function () {
      this.isMobile = window.innerWidth <= 900;
      if (window.innerWidth > 900) {
        this.typeHidden = "opacity";
        this.collapse = {
          first: true,
          second: true,
          third: true,
        };
      } else {
        this.typeHidden = "hidden";
      }
    },
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<template>
  <div class="navbar">
    <!--  クレハについて   -->
    <section class="main_nav__about" :class="{ 'is-footer': isFooter }">
      <div @click="handleCollapse('first')">
        <span>クレハについて</span>
        <img
          v-if="!collapse.first && !isFooter"
          src="../assets/img/common/circle-plus.svg"
          alt=""
        />
        <img
          v-if="collapse.first && !isFooter"
          src="../assets/img/common/circle-div.svg"
          alt=""
        />
      </div>
      <ul :class="{ [typeHidden]: !collapse.first && isMobile }">
        <li>
          <router-link to="/product/"> 事業と製品紹介 </router-link>
        </li>
        <li>
          <router-link to="/office/"> 事業所紹介 </router-link>
        </li>
        <li>
          <a href="https://www.kureha-saiyou.com/office/" target="_blank">
            <div class="menu__item--link">
              <span>各事業所近辺情報</span>
              <IconBase :width="12" iconColor="#000" class="icon_base"
                ><Blank
              /></IconBase>
            </div>
          </a>
        </li>
        <li>
          <router-link to="/keyword/">
            クレハがわかる！
            <span> 7のキーワード </span>
          </router-link>
        </li>
        <li>
          <router-link to="/kureha-quiz-test/">
            クレハ検定
            <span> 〜環境と社会への取り組み編〜 </span>
          </router-link>
        </li>
        <li>
          <router-link to="/career"> キャリアステップ </router-link>
        </li>
        <li>
          <router-link to="/faq/"> よくあるご質問 </router-link>
        </li>
        <li>
          <a
            :href="linkPdf"
            target="_blank"
          >
            <div class="menu__item--link">
              <span style="line-height: 22px"
                >採用活動における<br class="pc-only" />ハラスメント防止の<br
                  class="pc-only" /><span style="display: flex; align-items: center; gap: 8px">
                  取り組みについて
                  <IconBase
                    :width="12"
                    iconColor="#000"
                    class="icon_base"
                    style="min-width: 12px"
                    ><Blank
                  /></IconBase> </span
              ></span>
            </div>
          </a>
        </li>
      </ul>
    </section>
    <!--  【新卒】企画開発職系（総合職）    -->
    <section class="main_nav__newgraduate">
      <router-link
        v-if="!isMobile || isFooter"
        to="/newgraduate"
        :class="{ 'is-footer': isFooter }"
        @click="handleCollapseHeader"
      >
        <figure>
          <img
            src="../assets/img/common/new-graduate.jpg"
            alt="【新卒】企画開発職系（総合職）"
          />
        </figure>
        <span>【新卒】企画開発職系（総合職）</span>
        <div>
          <span>新卒採⽤</span>
          <span>企画開発職系（総合職）</span>
        </div>
        <img
          v-if="!collapse.second && !isFooter"
          src="../assets/img/common/circle-plus.svg"
          alt=""
        />
        <img
          v-if="collapse.second && !isFooter"
          src="../assets/img/common/circle-div.svg"
          alt=""
        />
        <img
          v-if="isFooter"
          src="../assets/img/common/circle-arrow-right-white.svg"
          alt=""
        />
      </router-link>
      <a
        v-if="!isFooter && isMobile"
        :class="{ 'is-footer': isFooter }"
        @click="handleCollapse('second')"
      >
        <figure>
          <img
            src="../assets/img/common/new-graduate.jpg"
            alt="【新卒】企画開発職系（総合職）"
          />
        </figure>
        <span>【新卒】企画開発職系（総合職）</span>
        <div>
          <span>新卒採⽤</span>
          <span>企画開発職系<br class="sp-only" />（総合職）</span>
        </div>
        <img
          v-show="!collapse.second && !isFooter"
          src="../assets/img/common/circle-plus.svg"
          alt=""
        />
        <img
          v-show="collapse.second && !isFooter"
          src="../assets/img/common/circle-div.svg"
          alt=""
        />
        <img
          v-show="isFooter"
          src="../assets/img/common/circle-arrow-right-white.svg"
          alt=""
        />
      </a>

      <ul :class="{ [typeHidden]: !collapse.second }">
        <li>
          <router-link to="/newgraduate">
            【新卒】企画開発職系（総合職）用 TOP
          </router-link>
        </li>
        <li>
          <router-link to="/info/"> 募集要項 </router-link>
        </li>
      </ul>
      <div :class="{ [typeHidden]: !collapse.second }">
        <div>
          <router-link to="/newgraduate/lab/">
            研究・技術職種 希望者向け
          </router-link>
          <ul>
            <li>
              <router-link to="/newgraduate/lab/">
                研究・技術職種 希望者向け TOP
              </router-link>
            </li>
            <li>
              <router-link to="/newgraduate/lab/work/">
                クレハの仕事
              </router-link>
            </li>
            <li>
              <router-link to="/newgraduate/lab/staff"> 社員紹介 </router-link>
            </li>
            <li>
              <router-link to="/newgraduate/lab/special">
                スペシャルコンテンツ
                <span> 〜研究開発の落とし⽳〜 </span>
              </router-link>
            </li>
          </ul>
        </div>
        <div>
          <router-link to="/newgraduate/gen">
            企画・営業職種 希望者向け
          </router-link>
          <ul>
            <li>
              <router-link to="/newgraduate/gen">
                企画・営業職種 希望者向け TOP
              </router-link>
            </li>
            <li>
              <router-link to="/newgraduate/gen/work">
                クレハの仕事
              </router-link>
            </li>
            <li>
              <router-link to="/newgraduate/gen/staff"> 社員紹介 </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div>
        <a href="https://job.axol.jp/bx/s/kureha_27/entry/" target="_blank">
          <img src="../assets/img/common/check.svg" alt="ENTRY" />
          <span> ENTRY </span>
        </a>
        <a href="https://job.axol.jp/bx/s/kureha_27/mypage/" target="_blank">
          <img src="../assets/img/common/page.svg" alt="ENTRY" />
          <span> MY PAGE </span>
        </a>
      </div>
    </section>
    <!--  【新卒】 実務推進職系（一般職）   -->
    <section class="main_nav__promotion">
      <a
        href="https://www.kureha-saiyou.com"
        :class="{ 'is-footer': isFooter }"
        target="_blank"
      >
        <figure>
          <img
            src="../assets/img/newgraduate/image_02.jpg"
            alt="【新卒】実務推進職系（一般職）"
          />
        </figure>
        <span>【新卒】実務推進職系<br />（一般職）</span>
        <div>
          <span>新卒採⽤</span>
          <span>実務推進職系<br class="sp-only" />(⼀般職)</span>
        </div>
        <IconBase :width="12" iconColor="#FFFFFF" class="icon_base"
          ><Blank
        /></IconBase>
        <img src="../assets/img/common/circle-copy.svg" alt="" />
      </a>
      <div></div>
      <router-link
        v-if="!isMobile || isFooter"
        to="/midcareer/"
        :class="[{ 'is-footer': isFooter }]"
        @click="isFooter ? handleCollapse('third') : () => {}"
      >
        <figure>
          <img src="../assets/img/common/recruit.jpg" alt="キャリア採⽤" />
        </figure>
        <span>キャリア採⽤</span>
        <img
          v-if="!collapse.third"
          src="../assets/img/common/circle-plus.svg"
          alt="キャリア採⽤"
          @click="handleCollapse('third')"
        />
        <img
          v-else
          src="../assets/img/common/circle-div.svg"
          alt="キャリア採⽤"
          @click="handleCollapse('third')"
        />
        <div
          v-if="isFooter"
          style="display: flex; align-items: center; padding-right: 16px"
        >
          <img src="../assets/img/common/circle-arrow-right-white.svg" alt="" />
        </div>
      </router-link>
      <a
        v-if="!isFooter && isMobile"
        :class="[{ 'is-footer': isFooter }]"
        @click="handleCollapse('third')"
      >
        <figure>
          <img src="../assets/img/common/recruit.jpg" alt="キャリア採⽤" />
        </figure>
        <span>キャリア採⽤</span>
        <img
          v-if="!collapse.third"
          src="../assets/img/common/circle-plus.svg"
          alt="キャリア採⽤"
        />
        <img
          v-else
          src="../assets/img/common/circle-div.svg"
          alt="キャリア採⽤"
        />
        <div
          v-if="isFooter"
          style="display: flex; align-items: center; padding-right: 16px"
        >
          <img src="../assets/img/common/circle-arrow-right-white.svg" alt="" />
        </div>
      </a>
      <ul v-if="collapse.third">
        <li>
          <router-link to="/midcareer/"> キャリア採用TOP </router-link>
        </li>
        <li>
          <a
            v-if="isHashUrl"
            style="cursor: pointer"
            @click="handleScrollTo('#employee')"
          >
            社員紹介
          </a>
          <router-link v-else to="/midcareer#employee"> 社員紹介 </router-link>
        </li>
        <li>
          <router-link to="/career/info"> キャリア採用情報 </router-link>
        </li>
      </ul>
    </section>
  </div>
</template>

<style scoped lang="scss">
@mixin menu-styled {
  ul {
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    row-gap: 15px;
    @media print, screen and (max-width: 900px) {
      row-gap: 24px;
    }
    & > li {
      max-width: fit-content;

      & > a {
        font-size: 16px;
        line-height: 32px;
        font-weight: 700;
        color: #000000;
        @media print, screen and (max-width: 900px) {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex-wrap: wrap;
          & > span {
            &:last-child {
              font-size: 14px;
              margin-left: 12px;
            }
          }
        }
        & > span {
          font-size: 12px;
          display: block;
          line-height: normal;
        }

        & > .menu__item--link {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          gap: 8px;
        }
      }
    }
  }
}

@mixin border-dash {
  border-left: 1px dashed #cccccc;
  border-right: 1px dashed #cccccc;
}

.sp-only {
  display: none;
  @media print, screen and (max-width: 400px) {
    display: block;
  }
}

.pc-only {
  display: block;
  @media print, screen and (max-width: 900px) {
    display: none;
  }
}

.navbar {
  display: flex;
  align-items: stretch;
  @media print, screen and (max-width: 900px) {
    padding: 0 24px;
    flex-direction: column;
  }
  & > section {
    padding: 35px 24px;
    &:first-child {
      @include border-dash;
    }
    &:last-child {
      @include border-dash;
    }

    @media print, screen and (max-width: 900px) {
      padding: 0;
      width: 100%;

      &:first-child {
        border: none;
      }
      &:last-child {
        border: none;
      }
    }
  }
}

.main_nav {
  width: 100%;
  background-color: rgba(255, 255, 255, 0.9);
  margin-top: -100vh;
  position: fixed;
  z-index: 90;
  transition: margin-top 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  overflow-y: scroll;
  max-height: calc(100% - 50px);
  &.open {
    margin-top: 0;
  }

  &__about {
    width: 24.25%;
    @media print, screen and (max-width: 900px) {
      margin-bottom: 50px;
      width: 100%;
    }

    &:is(.is-footer) {
      @media print, screen and (max-width: 900px) {
        display: none;
      }
    }

    & > div {
      width: 100%;
      //width: 220px;
      height: 48px;
      background: #3c3c3c;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: 700;
      color: #ffffff;
      box-sizing: border-box;
      & > img {
        display: none;
        @media print, screen and (max-width: 900px) {
          display: block;
        }
      }
      @media print, screen and (max-width: 900px) {
        cursor: pointer;
        width: 100%;
        justify-content: space-between;
        padding: 0 16px;
        font-size: 18px;
        height: 48px;
      }
    }

    @include menu-styled;
    & > ul {
      transition: all ease-in-out 0.5s;
      &:is(.hidden) {
        display: none;
      }

      &:is(.opacity) {
        opacity: 0;
      }
      @media print, screen and (max-width: 900px) {
        padding: 0 16px;
        margin-top: 40px;
      }
    }
  }

  &__newgraduate {
    width: 45.75%;
    @media print, screen and (max-width: 900px) {
      width: 100%;
    }
    & > a {
      min-width: 100%;
      &:first-child {
        margin: 0;
        background: linear-gradient(273.36deg, #3fa800 0.89%, #00797f 97.96%);
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        position: relative;
        @media print, screen and (max-width: 900px) {
          border-radius: 0;
          height: 112px;
          justify-content: flex-start;
        }
        & > figure {
          display: none;
          margin: 0;
          @media print, screen and (max-width: 900px) {
            display: block;
            height: 100%;
            width: 40%;
            & > img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          @media print, screen and (max-width: 400px) {
            width: 50%;
          }
        }

        & > img {
          display: none;
          position: absolute;
          right: 16px;
          top: 50%;
          cursor: pointer;
          transform: translateY(-50%);
          @media print, screen and (max-width: 900px) {
            display: block;
          }
        }

        & > span {
          &:nth-child(2) {
            color: white;
            font-size: 16px;
            font-weight: 700;
            @media print, screen and (max-width: 900px) {
              display: none;
            }
          }
        }
        & > div {
          display: none;
          box-sizing: border-box;
          @media print, screen and (max-width: 900px) {
            display: flex;
            justify-content: center;
            flex-direction: column;
            height: 100%;
            padding: 24px;

            & > span {
              display: block;
              color: white;
              font-weight: 700;
              &:last-child {
                font-size: 14px;
                line-height: normal;
              }
            }
          }
          @media print, screen and (max-width: 414px) {
            padding: 0 18px;
          }
        }

        &:is(.is-footer) {
          @media print, screen and (max-width: 900px) {
            height: 52px;
            border-radius: 6px;
            padding: 0 8px;
            box-sizing: border-box;
          }
          & > figure {
            @media print, screen and (max-width: 900px) {
              display: none;
            }
          }
          & > span {
            @media print, screen and (max-width: 900px) {
              display: block;
            }
          }
          & > div {
            @media print, screen and (max-width: 900px) {
              display: none;
            }
          }
        }
      }
    }
    & > div {
      &:nth-child(3) {
        transition: all ease-in-out 0.5s;
        display: flex;
        align-items: stretch;
        justify-content: space-between;
        column-gap: 28px;
        &:is(.hidden) {
          display: none;
        }

        &:is(.opacity) {
          opacity: 0;
        }
        @media print, screen and (max-width: 900px) {
          flex-wrap: wrap;
          padding-left: 24px;
        }
        & > div {
          width: 100%;
          & > a {
            padding: 0 4px;
            min-height: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 6px;
            color: white;
            font-weight: 700;
            font-size: 14px;
            text-align: center;
            @media print, screen and (max-width: 900px) {
              border-radius: 0;
              font-size: 16px;
              padding: 0 26px;
              justify-content: flex-start;
              height: 44px;
            }
          }

          @include menu-styled;

          & > ul {
            box-sizing: border-box;
            @media print, screen and (max-width: 900px) {
              margin-top: 40px;
              padding-left: 26px;
            }
          }

          &:first-child {
            @media print, screen and (max-width: 900px) {
              margin-bottom: 40px;
            }
            & > a {
              background: var(--darkGreen);
            }

            & > ul {
              & > li {
                &:first-child {
                  display: none;
                  @media print, screen and (max-width: 900px) {
                    display: block;
                  }
                }
                & > a {
                  color: var(--darkGreen);
                }
              }
            }
          }
          &:last-child {
            & > a {
              background: #3fa800;
            }
            & > ul {
              @media print, screen and (max-width: 900px) {
                margin-bottom: 20px;
              }
              & > li {
                &:first-child {
                  display: none;
                  @media print, screen and (max-width: 900px) {
                    display: block;
                  }
                }
                & > a {
                  color: #3fa800;
                }
              }
            }
          }
        }
      }

      &:last-child {
        margin-top: 33px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        column-gap: 28px;
        @media print, screen and (max-width: 900px) {
          margin-top: 20px !important;
          column-gap: 16px;
        }
        & > a {
          display: flex;
          align-items: center;
          justify-content: center;
          column-gap: 14px;
          width: 100%;
          height: 45px;
          background-color: white;
          border-radius: 6px;
          border: 2px solid;
          @media print, screen and (max-width: 900px) {
            height: 45px;
          }
          & > img {
            @media print, screen and (max-width: 900px) {
              width: 15px;
            }
          }
          & > span {
            font-weight: 700;
            font-size: 20px;
            @media print, screen and (max-width: 900px) {
              font-size: 18px;
            }
          }

          &:first-child {
            border-color: var(--darkGreen);
            & > span {
              color: var(--darkGreen);
            }
          }

          &:last-child {
            border-color: var(--lightGreen);
            & > span {
              color: var(--lightGreen);
            }
          }
        }
      }
    }
    & > a {
      display: block;
      max-width: fit-content;
      font-size: 16px;
      font-weight: 700;
      line-height: 200%;
      color: #209140;
      margin: 32px auto;
    }

    @include menu-styled;

    & > ul {
      transition: all ease-in-out 0.5s;
      margin: 32px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      &:is(.hidden) {
        display: none;
      }

      &:is(.opacity) {
        opacity: 0;
      }
      @media print, screen and (max-width: 900px) {
        flex-direction: column;
        align-items: flex-start;
        padding-left: 24px;
      }
      & > li {
        &:first-child {
          display: none;
          @media print, screen and (max-width: 900px) {
            display: block;
            margin-left: -10px;
          }
        }
        & > a {
          color: #209140;
        }
      }
    }
  }

  &__promotion {
    width: 30%;
    @media print, screen and (max-width: 900px) {
      margin-top: 50px;
      width: 100%;
    }
    & > a {
      &:first-child {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 48px;
        background: #00a589;
        border-radius: 6px;
        position: relative;
        padding: 0 8px 0 0;
        column-gap: 4px;
        @media print, screen and (min-width: 900px) and (max-width: 1100px) {
          justify-content: space-between;
        }
        @media print, screen and (max-width: 900px) {
          border-radius: 0;
          padding: 0;
          height: 112px;
          justify-content: flex-start;
          column-gap: 0;
        }

        & > span {
          color: white;
          font-size: 16px;
          font-weight: 700;
          & > br {
            display: none;
            @media print,
              screen and (min-width: 900px) and (max-width: 1100px) {
              display: block;
            }
          }
        }
        & > figure {
          display: none;
          margin: 0;
          @media print, screen and (max-width: 900px) {
            width: 40%;
            display: block;
            height: 100%;
            & > img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          @media print, screen and (max-width: 400px) {
            width: 50%;
          }
        }
        & > img {
          display: none;
          position: absolute;
          right: 16px;
          top: 50%;
          cursor: pointer;
          transform: translateY(-50%);
          @media print, screen and (max-width: 900px) {
            display: block;
          }
        }

        & > span {
          &:nth-child(2) {
            color: white;
            font-size: 16px;
            font-weight: 700;
            @media print, screen and (max-width: 900px) {
              display: none;
            }
          }
        }
        & > svg {
          @media print, screen and (max-width: 900px) {
            display: none;
          }
        }
        & > div {
          display: none;
          box-sizing: border-box;
          @media print, screen and (max-width: 900px) {
            display: flex;
            justify-content: center;
            flex-direction: column;
            height: 100%;
            padding: 24px;

            & > span {
              display: block;
              color: white;
              font-weight: 700;
              &:last-child {
                font-size: 14px;
                line-height: normal;
              }
            }
          }
          @media print, screen and (max-width: 414px) {
            padding: 0 18px;
          }
        }

        &:is(.is-footer) {
          @media print, screen and (max-width: 900px) {
            height: 52px;
            border-radius: 6px;
            padding: 0 8px;
          }
          & > span {
            @media print, screen and (max-width: 900px) {
              display: block;
            }
          }
          & > div {
            @media print, screen and (max-width: 900px) {
              display: none;
            }
          }
          & > figure {
            @media print, screen and (max-width: 900px) {
              display: none;
            }
          }
        }
      }

      &:nth-child(3) {
        margin: 32px auto;
        @media print, screen and (max-width: 900px) {
          margin: 50px auto 0 auto;
        }
        color: white;
        font-weight: 700;
        font-size: 16px;
        min-height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--darkBlue);
        border-radius: 6px;
        position: relative;
        @media print, screen and (max-width: 900px) {
          border-radius: 0;
          height: 112px;
          justify-content: flex-start;
        }
        & > figure {
          display: none;
          margin: 0;
          @media print, screen and (max-width: 900px) {
            width: 40%;
            display: block;
            height: 100%;
            & > img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          @media print, screen and (max-width: 400px) {
            width: 50%;
          }
        }
        & > img {
          display: none;
          position: absolute;
          right: 16px;
          top: 50%;
          cursor: pointer;
          transform: translateY(-50%);
          @media print, screen and (max-width: 900px) {
            display: block;
          }
        }

        & > span {
          padding: 0 24px;
          @media print, screen and (max-width: 414px) {
            padding: 0 18px;
          }
        }

        &:is(.is-footer) {
          display: flex;
          align-items: center;
          justify-content: center;
          @media print, screen and (max-width: 900px) {
            height: 52px;
            border-radius: 6px;
            justify-content: space-between;
          }
          & > figure {
            @media print, screen and (max-width: 900px) {
              display: none;
            }
          }

          & > div {
            display: none !important;
            @media print, screen and (max-width: 900px) {
              display: flex !important;
            }
          }

          & > img {
            @media print, screen and (max-width: 900px) {
              display: none;
            }
          }
        }
      }
    }

    & > div {
      height: 32px;
      margin: 32px auto;
      @media print, screen and (max-width: 900px) {
        margin: 50px auto 0 auto;
        &:nth-child(2) {
          display: none;
        }
      }
    }

    @include menu-styled;

    & > ul {
      @media print, screen and (max-width: 900px) {
        padding-left: 24px;
      }
      & > li {
        &:first-child {
          display: none;
          @media print, screen and (max-width: 900px) {
            display: block;
          }
        }
        a {
          color: var(--darkBlue);
        }
      }
    }
  }
}
</style>
